import { useState, useEffect, useCallback } from 'react';

/**
 * Спільний стан шапки «Документи» (/docs).
 *
 * Тут живе лише активна вкладка, і потрібна вона НЕ сторінці (та й сама знає,
 * що показує), а топбару: селектор СЕС має з'являтися на «Договорах»,
 * «Звітності» й «Технічній документації» та зникати на «Нормативних актах» —
 * закони однакові для всього портфелю, і вибір станції там нічого не означає.
 * Без цього каналу топбар не знає, яку вкладку відкрито.
 *
 * Прийом той самий, що useContractsUi / useAssetsUi / useUeexUi: модульний
 * стан плюс подія, бо топбар і сторінка стоять у різних гілках дерева і
 * спільного React-контексту не мають.
 */
export type DocsTabId = 'legal' | 'contracts' | 'reports' | 'technical';

/** Вкладки, де документ належить конкретній СЕС, а не юрособі цілком. */
export const DOCS_STATION_TABS: DocsTabId[] = ['contracts', 'reports', 'technical'];

const EV = 'helios:docs-ui-change';

// Типова вкладка — перша в ряду («Договори»): розділ має відкриватись саме
// на ній. Була 'legal', але нормативні акти переїхали в кінець ряду.
const state = { tab: 'contracts' as DocsTabId };

const emit = () => window.dispatchEvent(new CustomEvent(EV));

export function useDocsUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);

  const setTab = useCallback((v: DocsTabId) => { if (state.tab !== v) { state.tab = v; emit(); } }, []);

  return { tab: state.tab, setTab };
}

/** Для топбару: читання без підписки не потрібне, але прапорець зручний. */
export function docsTabNeedsStation(tab: DocsTabId): boolean {
  return DOCS_STATION_TABS.includes(tab);
}
